import { render, staticRenderFns } from "./colunm.vue?vue&type=template&id=0b4c7b0e&scoped=true&"
import script from "./colunm.vue?vue&type=script&lang=ts&"
export * from "./colunm.vue?vue&type=script&lang=ts&"
import style0 from "./colunm.vue?vue&type=style&index=0&id=0b4c7b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c7b0e",
  null
  
)

export default component.exports